import { render } from "./form.vue?vue&type=template&id=8d4cab4c"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
script.render = render

export default script